<template>
  <b-modal
    id="add-cash"
    ref="add-cash"
    body-class="p-10"
    centered
    title="Add Cash"
    @show="setModalData"
    @hide="resetModal"
    @ok="addCash"
  >
    <b-overlay
      id="overlay-add-cash"
      :show="isModalLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <label
        class="form__row"
      >
        <span class="form__row-label">Amount Cash ($)</span>
        <input
          v-model.number="amount"
          type="number"
          class="input"
        />
      </label>
      <b-form-group label="Select Credit Card">
        <CreditCardRadioBlock 
          v-for="card in cardsList"
          :key="card.id"
          :card="card"
          :show-delete-card="false"
        />
        <b-button
          variant="primary"
          class="w-100 mt-2"
          v-b-modal.add-new-card
        >
          Add New Credit Card +
        </b-button>
      </b-form-group>
    </b-overlay>
    <template #modal-footer="{ cancel, ok }">
      <div class="w-100 d-flex justify-content-between">
        <b-button
          class="border border-primary"
          variant="outline-primary" 
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="isOkButtonDisabled"
          @click="ok()"
        >
          Add payment
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { getUserData } from '@/auth/utils'
import { mapGetters } from 'vuex'
import store from '@/store'

import { BModal, BButton, BOverlay, BFormGroup } from 'bootstrap-vue'
import CreditCardRadioBlock from '@/components/site/CreditCardRadioBlock.vue'
import { setStatusModalData } from '@core/mixins/setStatusModalData'

export default {
  components: {
    BModal,
    BButton,
    BOverlay,
    BFormGroup,

    CreditCardRadioBlock,
  },
  
  mixins: [ setStatusModalData ],
  data() {
    return {
      userId: getUserData().id,
      amount: 0,
    }
  },
  computed: {
    ...mapGetters({
      cardsList: 'cards/getCardsList',
      selectedCard: 'cards/getSelectedCreditCard',
    }),
    isModalLoading: {
      get: function () {
        return store.getters['paymentPortal/getIsModalLoaidng']
      },
      set: function (val) {
        store.commit('paymentPortal/SET_MODAL_LOADING_STATE', val)
      },
    },
    isOkButtonDisabled() {
      return this.amount <= 0 || !this.selectedCard
    }
  },
  methods: {
    async setModalData() {
      this.isModalLoading = true
      await store.dispatch('cards/loadCards')
      this.isModalLoading = false
    },
    resetModal() {
      store.commit('cards/SET_SELECTED_CREDIT_CARD', null)
      this.amount = 0
    },
    async addCash(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.submitButtonIsLoading = true
      this.isModalLoading = true

      const queryParams = {
        user_id: this.userId,
        amount: this.amount,
        card_id: this.selectedCard,
        is_cashbank: 1,
      }

      try {
        await store.dispatch('paymentPortal/sendNewTransaction', queryParams)

        this.showStatusModal({
          title: 'Make payment',
          status: 'Success',
          header: 'Successfully added to Cash Bank',
          message: '',
        })

        store.dispatch('paymentPortal/refreshData')
      } catch (e) {
        this.showStatusModal({
          title: 'Make a payment',
          status: 'Failed',
          header: 'Your payment failed',
          message: '',
        })
      } finally {
        this.submitButtonIsLoading = false
        this.isModalLoading = false
      }
    },
    showStatusModal(data) {
      this.setStatusModalData(data)
      this.$bvModal.hide('add-cash')
      this.$bvModal.show('status-modal')
    },
  },
}
</script>

<style>

</style>